import {useState} from "react";

import LoaderDefault from "../../components/common/Loader.default/Loader.default";
import AgentFilters from "../../components/project/Agent.filters/Agent.filters";
import { Stack, Divider, Box} from "@mantine/core";
import {Search} from "tabler-icons-react";
import { IAgentReviewQuery } from "../../api/Base/Base.types";
import AgentFiltersManager from "../../components/project/Agent.filters/Agent.filters.manager";

import {useAgentReviewSearch} from "../../api/AgentSignup/AgentSignup.hooks";
import AgentSearchTable from "../../components/project/Agent.search.table/Agent.search.table";
import {Outlet, useOutlet} from "react-router-dom";

function AgentReviewSearch() {
    const outlet = useOutlet();
    const [query, setQuery] = useState<IAgentReviewQuery>(getLocalStorageQuery());
    const {isLoading: isAgentReviewSearchLoading, data: agentReviewSearchData} = useAgentReviewSearch(query);

    function onSubmitQuery(values: IAgentReviewQuery) {
        let serializedQuery = AgentFiltersManager
            .setDeserializedValues(values)
            .serializeQuery()
            .setQueryToLocalStorage()
            .setInitialQuerySent()
            .getValues();
        setQuery(serializedQuery);
    }

    function getLocalStorageQuery() {
        return AgentFiltersManager
            .getQueryFromLocalStorage()
            .getValues();
    }

    function getAgentFiltersInitialValues() {
        return AgentFiltersManager
            .setSerializedValues(
                AgentFiltersManager
                    .getQueryFromLocalStorage()
                    .getValues()
            )
            .deserializeQuery()
            .getValues()
    }

    function renderList() {
        if (isAgentReviewSearchLoading || !agentReviewSearchData) {
            return <LoaderDefault text="Loading..."/>
        } else {
            return (
                <>
                    <Divider
                        my="xs"
                        variant="dashed"
                        labelPosition="center"
                        label={
                            <>
                                <Search size={12}/>
                                <Box ml={5}>Search results</Box>
                            </>
                        }
                    />
                    <AgentSearchTable agentData={agentReviewSearchData}/>
                </>
            )
        }
    }

    if (outlet){
        return outlet;
    }

    return (
        <Stack>
            <AgentFilters onSubmitQuery={onSubmitQuery} initialValues={getAgentFiltersInitialValues()}></AgentFilters>
            {renderList()}
            <Outlet/>
        </Stack>
    )
}

export default AgentReviewSearch;